import configData from '../../src/config.json';
import { jwtDecode } from 'jwt-decode';
// export const Decrypt = (v) => {
//     var CryptoJS = require("crypto-js");
//     // Decrypt
//     var bytes = CryptoJS.AES.decrypt(v, configData.CRYPT_KEY);
//     return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// }
// export const Encrypt = (v) => {
//     // Encrypt
//     var CryptoJS = require("crypto-js");
//     var encData = CryptoJS.AES.encrypt(JSON.stringify(v), configData.CRYPT_KEY).toString();
//     return encData;
// }
export const GetSignedInUserInfo = () => {
    return jwtDecode(sessionStorage.getItem('token')).result;
}

export const GetUserInfo = () => {
    return JSON.parse(sessionStorage.getItem('userInfo'));
}